export class IncrementExploreStep {
  static readonly type = '[Explore] Increment explore step';
}

export class DecrementExploreStep {
  static readonly type = '[Explore] Decrement explore step';
}

export class UpdateExploreStep {
  static readonly type = '[Explore] Set explore step';
  constructor(public payload: number) {}
}

export class InitForm {
  static readonly type = '[Explore] Init Data';
  constructor(public formConfig = null) {}
}

export class InitFormSuccess {
  static readonly type = '[Explore] Init Data Success';
  constructor(public payload: any, public formConfig = null) {}
}

export class InitFormFail {
  static readonly type = '[Explore] Init Data Fail';
  constructor(public err: any) {}
}

export class UpdateData {
  static readonly type = '[Explore] Update Data';
  constructor(public payload: any) {}
}
